import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const ToyotaFinancePage = () => {
  return (
    <LenderPageTemplate
      lenderName="Toyota"
      slug="/lenders/mis-sold-toyota-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default ToyotaFinancePage
